import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AbstractApi } from './abstract.api';

export enum DataProductType {
  MASTER = 'master',
  CONNECT = 'connect',
  PRODUCT = 'product',
}

@Injectable({
  providedIn: 'root',
})
export class PoolDataApi extends AbstractApi {
  public getPoolDatas(
    poolId: string,
    length: number = 10,
    offset: number = 0,
    startDate: number | null = null,
    endDate: number | null = null,
  ): Promise<any[]> {
    return firstValueFrom(
      this.http.get<any[]>(`${this.backend}/api/v1/pool/${poolId}/data`, {
        params: {
          length: length.toString(),
          offset: offset.toString(),
          ...(startDate !== null && { startDate: startDate.toString() }),
          ...(endDate !== null && { endDate: endDate.toString() }),
        },
      }),
    );
  }

  public getPoolProductDatas(
    poolId: string,
    productType: DataProductType,
    modelIdentifier: string,
    property: string,
    aggregate: string,
    startDate: number | null = null,
    endDate: number | null = null,
    mode: string | null = null,
  ): Promise<any[]> {
    return firstValueFrom(
      this.http.get<any[]>(
        `${this.backend}/api/v1/pool/${poolId}/${productType}/${modelIdentifier}/data`,
        {
          params: {
            property,
            aggregate: aggregate || 'avg',
            ...(startDate !== null && { startDate: startDate.toString() }),
            ...(endDate !== null && { endDate: endDate.toString() }),
            ...(mode !== null && { mode: mode.toString() }),
          },
        },
      ),
    );
  }

  public getPoolProductDatasProperties(
    poolId: string,
    productType: DataProductType,
    modelIdentifier: string,
    properties: string[],
    aggregate: string,
    startDate: number | null = null,
    endDate: number | null = null,
  ): Promise<any[]> {
    return firstValueFrom(
      this.http.get<any[]>(
        `${this.backend}/api/v1/pool/${poolId}/${productType}/${modelIdentifier}/data`,
        {
          params: {
            properties: properties.join(';'),
            aggregate: aggregate || 'avg',
            ...(startDate !== null && { startDate: startDate.toString() }),
            ...(endDate !== null && { endDate: endDate.toString() }),
          },
        },
      ),
    );
  }
}
